/* [BD feat] JS for Header Mega Menu Accordion, Mobile menu drawer start */

document.addEventListener('DOMContentLoaded', function () {
  // When a megamenu title is clicked
const menuTitles = document.querySelectorAll(".desktop-megamenu-title");

menuTitles.forEach(title => {
  title.addEventListener("click", function(e) {
    e.preventDefault(); // Prevent link navigation if needed

    const currentMenu = this.parentElement;
    const submenu = currentMenu.querySelector(".linklist");      
    // Toggle current menu
    if (currentMenu.classList.contains("active")) {
      currentMenu.classList.remove("active");
      slideUp(submenu);
    } else {
      currentMenu.classList.add("active");
      slideDownn(submenu);
    }
  });
});

// Slide down function
function slideDownn(element) {
  element.style.display = "block"; // Make sure it's visible
  const height = element.scrollHeight + "px"; // Get scroll height for smooth transition
  element.style.height = '0'; // Start with collapsed height
  element.style.transition = "height 0.3s ease-out, opacity 0.3s ease-out";
  element.style.overflow = "hidden"; // Ensure the content doesn't overflow during transition
  
  // Trigger reflow to ensure the transition starts
  requestAnimationFrame(() => {
    element.style.height = height; // Animate to full height
    element.style.opacity = "1";
  });
}

// Slide up function
function slideUp(element) {
  element.style.transition = "height 0.3s ease-in, opacity 0.3s ease-in";
  const height = element.scrollHeight + "px"; // Get current height before collapsing
  element.style.height = height; // Ensure it's fully expanded
  element.style.opacity = "0"; // Fade out the content
  
  // Trigger the collapse with transition
  requestAnimationFrame(() => {
    element.style.height = '0'; // Collapse to 0 height
  });

  setTimeout(() => {
    element.style.display = "none"; // Hide the element after the animation completes
    element.style.height = ""; // Reset the height property
    element.style.opacity = "1"; // Reset opacity
    element.style.overflow = ""; // Reset overflow property
    element.style.transition = ""; // Reset the transition
  }, 300); // Match the duration of the transition
}

  const menuItems = document.querySelectorAll(".list-menu-item.megamenu-active");
  const overlayHeader = document.querySelector(".overlay-header");

  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      document.body.classList.add("active-megamenu");
      overlayHeader.classList.add("active");
    });

    item.addEventListener("mouseleave", () => {
      document.body.classList.remove("active-megamenu");
      overlayHeader.classList.remove("active");
    });
  });

  const drawerCartIcons = document.querySelectorAll('.drawer-cart-icon');
  drawerCartIcons.forEach(drawerCartIcon => {
    drawerCartIcon.addEventListener('click', function(event) {        
      event.preventDefault();             
      const mobileHeaderNav = document.querySelector('.mobile-header-nav');
      const body = document.body;
      const mobileOverlayHeader = document.querySelector('.mobile-overlay-header');
      
      if (mobileHeaderNav) mobileHeaderNav.classList.remove('toggle');
      body.classList.remove('opened-drawer');
      if (mobileOverlayHeader) mobileOverlayHeader.classList.remove('overlay');
        
      const cartIcon = document.querySelector('.header__right [data-js-cart-icon]');        
      if (cartIcon) {
        cartIcon.click();
        if(document.querySelector('.dropdown-menus.show')){
          document.querySelector('.dropdown-menus.show').classList.remove('show');            
        }
        if(document.querySelector('.sub-mobile-submenu-wrapper.open-submenu-wrapper')){
          document.querySelector('.sub-mobile-submenu-wrapper.open-submenu-wrapper').classList.remove('open-submenu-wrapper');            
        }          
      }
    });
  });


  const headerIcons = document.querySelectorAll('.header__menu-icon');
  headerIcons.forEach(headerIcon => {
    headerIcon.addEventListener('click', function(event) {      
      if(document.querySelector('.story__modal.open')){
        document.querySelector('.story__modal.open').classList.remove('open');
        document.body.classList.remove('story__modal--opened');
      }
      document.querySelector('.mobile-header-nav')?.classList.toggle('toggle');
      document.body.classList.toggle('opened-drawer');
      document.querySelector('.mobile-overlay-header')?.classList.toggle('overlay');
    });
  });

  document.addEventListener('click', function(event) {
    if (event.target.closest('.close-button')) {
      document.querySelector('.mobile-header-nav')?.classList.remove('toggle');
      document.body.classList.remove('opened-drawer');
      document.querySelector('.mobile-overlay-header')?.classList.remove('overlay');
    }
  });

  document.addEventListener('mouseup', function(e) {
  const container = document.querySelector('.mobile-header-nav');
  const overlay = document.querySelector('.mobile-overlay-header');

  if (
    container &&
    !container.contains(e.target) &&
    container.classList.contains('toggle')
  ) {
    container.classList.remove('toggle');
    overlay?.classList.remove('overlay');
    document.body.classList.remove('opened-drawer');
  }
});

document.addEventListener('click', function(event) {
  if (event.target.closest('.accordion-back-icon')) {
    event.preventDefault();
    document.querySelectorAll('.dropdown-menus').forEach(el => el.classList.remove('show'));
    document.querySelectorAll('.drawer-main').forEach(el => el.classList.remove('main-submenu-open'));
    document.querySelectorAll('.sub-mobile-submenu-wrapper').forEach(el => el.classList.remove('open-submenu-wrapper'));
  }
});

document.addEventListener('click', function(event) {
  const accordion = event.target.closest('.drawer-main .accordion');
  if (accordion) {
    event.preventDefault();

    document.querySelector('.mobile-header-menu-nav')?.classList.add('submenu-open');
    document.querySelector('.drawer-main')?.classList.add('main-submenu-open');

    const submenu = accordion.nextElementSibling;
    // setupGallerySliders();
    if (submenu?.classList.contains('show')) {
      submenu.classList.remove('show');
      submenu.querySelectorAll('.sub-mobile-submenu-wrapper').forEach(el => {
        el.classList.remove('open-submenu-wrapper');
      });
    } else {
      
      const drawerMain = accordion.closest('.drawer-main');
      drawerMain?.querySelectorAll('.mobile-megamenu-product').forEach(el => {
        el.classList.remove('show');
      });

      submenu?.classList.add('show');
      var carousel = submenu.querySelector('.megamenu-product-wrapper');
      if (carousel && carousel.flickityInstance) {
        carousel.flickityInstance.destroy();
        carousel.flickityInstance = null;
      }
      setTimeout(() => {
        submenu?.querySelectorAll('.sub-mobile-submenu-wrapper').forEach(el => {
          el.classList.add('open-submenu-wrapper');
        });          
        var carousel = submenu.querySelector('.megamenu-product-wrapper');          
        if (!carousel || carousel.flickityInstance) return;  
        var flickityInstance = new Flickity(carousel, {
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          groupCells: 1,
          pageDots: false,
          prevNextButtons: false,
        });
        carousel.flickityInstance = flickityInstance;

      }, 500);
    }
  }
});

function blogSlider(section) {
  var slider = section.querySelector('.blog-list-wrapper');

  if (!slider || slider.flickityInstance) return;

  var flickityInstance = new Flickity(slider, {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    groupCells: 1,
    pageDots: false,
    prevNextButtons: false,
  });
  slider.flickityInstance = flickityInstance;
}

function destroyBlogSlider(section) {
  var slider = section.querySelector('.blog-list-wrapper');
  if (slider && slider.flickityInstance) {
    slider.flickityInstance.destroy();
    slider.flickityInstance = null;
  }
}

function setupBlogSliders() {
  document.querySelectorAll('.main-blog-list').forEach(function (section) {
    var slider = section.querySelector('.blog-list-wrapper');
    if (!slider) return;

    if (!slider.flickityInstance) {
      blogSlider(section);
    }
  });
}


setupBlogSliders();

// Shopify section load
document.addEventListener('shopify:section:load', function (event) {
  const section = document.querySelector('.main-blog-list[data-section-id="' + event.detail.sectionId + '"]');
  if (section) {
    setTimeout(() => blogSlider(section), 500);
  }
});

// Shopify section unload
document.addEventListener('shopify:section:unload', function (event) {
  const section = document.querySelector('.main-blog-list[data-section-id="' + event.detail.sectionId + '"]');
  if (section) {
    destroyBlogSlider(section);
  }
});

// Shopify theme settings update
document.addEventListener('shopify:theme-settings:updated', setupBlogSliders);


function initGallerySlider(section) {
  var carousel = section.querySelector('.megamenu-product-wrapper');

  if (!carousel || carousel.flickityInstance) return;

  var flickityInstance = new Flickity(carousel, {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    groupCells: 1,
    pageDots: false,
    prevNextButtons: false,
  });
  carousel.flickityInstance = flickityInstance;
}

function destroyGallerySlider(section) {
  var carousel = section.querySelector('.megamenu-product-wrapper');
  if (carousel && carousel.flickityInstance) {
    carousel.flickityInstance.destroy();
    carousel.flickityInstance = null;
  }
}

function setupGallerySliders() {
  document.querySelectorAll('.megamenu-product').forEach(function (section) {
    var carousel = section.querySelector('.megamenu-product-wrapper');
    if (!carousel) return;

    if (!carousel.flickityInstance) {
      initGallerySlider(section);
    }
  });
}

window.addEventListener('load', function () {

setupGallerySliders();

});
});


document.addEventListener('DOMContentLoaded', function () {

// Helper functions (same as before)
function slideUp(element, duration = 350) {
  element.style.height = element.offsetHeight + 'px';
  element.offsetHeight;
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';
  element.style.boxSizing = 'border-box';
  element.style.overflow = 'hidden';
  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;

  window.setTimeout(function () {
    element.style.display = 'none';
    element.classList.remove('show');
    element.style.removeProperty('height');
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
  }, duration);
}

function slideDown(element, duration = 350) {
  element.style.removeProperty('display');
  let display = window.getComputedStyle(element).display;
  if (display === 'none') display = 'block';
  element.style.display = display;

  let height = element.offsetHeight;
  element.style.overflow = 'hidden';
  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;
  element.offsetHeight;

  element.style.boxSizing = 'border-box';
  element.style.transitionProperty = 'height, margin, padding';
  element.style.transitionDuration = duration + 'ms';
  element.style.height = height + 'px';
  element.style.removeProperty('padding-top');
  element.style.removeProperty('padding-bottom');
  element.style.removeProperty('margin-top');
  element.style.removeProperty('margin-bottom');

  window.setTimeout(function () {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    element.style.removeProperty('transition-duration');
    element.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(element, duration = 350) {
  if (window.getComputedStyle(element).display === 'none') {
    element.classList.add('show');
    slideDown(element, duration);
  } else {
    slideUp(element, duration);
  }
}

// Directly bind click event to all .accordion-menu elements
const accordionTriggers = document.querySelectorAll('.drawer-main .megamenu-title-mobile');

accordionTriggers.forEach(trigger => {
  trigger.addEventListener('click', function (event) {
    event.preventDefault();

    const drawer = trigger.closest('.drawer-main');
    const content = trigger.nextElementSibling;

    // Close all open dropdowns
    drawer.querySelectorAll('.mobile-megamenu-item .dropdown-grandchild.show').forEach(element => {
      slideUp(element, 350);
    });

    // Remove active states
    drawer.querySelectorAll('.accordion-menu').forEach(el => el.classList.remove('open-dropdwan'));
    drawer.querySelectorAll('.child-accordion-plus-icon').forEach(icon => icon.classList.remove('is-open'));

    // Toggle current
    if (!content.classList.contains('show')) {
      content.classList.add('show');
      slideDown(content, 350);
      trigger.classList.add('open-dropdwan');
      trigger.querySelector('.child-accordion-plus-icon')?.classList.add('is-open');
    }
  });
});

});
/* [BD feat] JS for Header Mega Menu Accordion, Mobile menu drawer end */